ImagesController.$inject = [
    '$scope',
    '$state',
    '$stateParams',
    '$translate',
    'ModalService',
    'PaginationService',
    'ImagesService',
    'ImagesTypesService',
    'notification',
    '$transitions',
    'MOPService'
];

export default function ImagesController(
    $scope,
    $state,
    $stateParams,
    $translate,
    ModalService,
    PaginationService,
    ImagesService,
    ImagesTypesService,
    notification,
    $transitions,
    MOPService
) {
    const vm = this;
    const watchers = [];

    let previousTableState;
    vm.selectedImageId = undefined;
    vm.lastSelected = undefined;

    vm.loading = false;
    vm.params = $stateParams;
    vm.state = $state;
    vm.images = [];

    vm.slideWidth = '500px';
    vm.slideMargin = {
        'margin-right': '0px',
        'transition-duration': '0.5s',
        'transition-animation': 'margin-right',
        height: '100%'
    };

    vm.itemsByPageOptions = [20, 100, 200];
    vm.itemsByPage = vm.itemsByPageOptions[0];
    vm.getTypes = getTypes;

    vm.selectImage = selectImage;
    vm.isImageSelected = isImageSelected;
    vm.showDetail = showDetail;
    vm.closeDetail = closeDetail;
    vm.loadImages = loadImages;
    vm.deleteImage = deleteImage;
    vm.setSelected = setSelected;
    //vm.eraseAllFilters = eraseAllFilters;

    vm.print = print;
    vm.MOPService = MOPService;

    vm.$onInit = () => {
        vm.MOPService.setMop([{ title: 'IMAGES.BREADCRUMBS.IMAGES_LIST', filename: 'Images.pdf', application: 'massia' }]);
        $transitions.onSuccess({}, stateChangeSuccessFunc);
        //$transitions.onSuccess({}, stateChangeSuccessFunc);
        watchers.push($scope.$on('$destroy', dispose));

        if (shouldSetSelectedId()) {
            vm.setSelected({ id: parseInt($state.params.id) });
        }

        getTypes();
    };

    vm.$onDestroy = () => {
        vm.MOPService.resetMop();
    };

    function stateChangeSuccessFunc(event, toState) {
        if (!$state.params.id) {
            vm.setSelected();
        } else if ($state.params.id) {
            vm.setSelected({ id: parseInt($state.params.id) });
        }
    }

    async function getTypes(event, toState) {
        vm.types = await ImagesTypesService.getAll();
    }

    function setSelected(image) {
        if (image && image.id) {
            vm.selectedImageId = $stateParams.id;
            vm.lastSelected = vm.selectedImageId;
            vm.slideMargin['margin-right'] = vm.slideWidth;
        } else {
            vm.selectedImageId = undefined;
            vm.slideMargin['margin-right'] = '0px';
        }
    }

    function shouldSetSelectedId() {
        return $state && $state.current && $state.current.name && $state.current.name === 'images.list.detail' && $stateParams && $stateParams.id;
    }

    function selectImage(image) {
        if (image && image.id) {
            if (vm.selectedImageId !== image.id) {
                vm.selectedImageId = image.id;
                showDetail(image.id);
            } else {
                vm.selectedImageId = undefined;
                closeDetail();
            }
        }
    }

    function isImageSelected(image) {
        return image && image.id && vm.selectedImageId === image.id;
    }

    function showDetail(imageId) {
        $state.go('images.list.detail', { id: imageId });
    }

    function closeDetail() {
        $state.go('images.list');
    }

    async function loadImages(tableState) {
        startLoading();

        if ($state && $state.current && $state.current.name !== 'images.list') {
            $state.go('images.list');
        }

        if (tableState) {
            previousTableState = tableState;
        }

        const filters = PaginationService.getFilters(previousTableState);
        const sorts = PaginationService.getSorts(previousTableState);
        const pagination = PaginationService.getPagination(previousTableState);

        vm.images = [];

        try {
            const data = await ImagesService.getImages(filters, sorts, pagination);

            vm.images = data.items;

            if (previousTableState) {
                PaginationService.setTableState(data.skip, data.take, data.total, previousTableState);
            }
        } catch (ex) {
            notification.error(ex.data);
        } finally {
            stopLoading();
        }
    }

    async function deleteImage(image) {
        if (image && image.id) {
            const modalInstance = ModalService.confirm({
                modalTitle: $translate.instant('IMAGES.DELETE.TITLE', { code: image.libelle }),
                modalMsg: $translate.instant('IMAGES.DELETE.MESSAGE'),
                headerClass: 'modal-danger'
            });

            modalInstance.result.then(async function () {
                startLoading();
                try {
                    await ImagesService.deleteImageById(image.id);
                    notification.success($translate.instant('IMAGES.DELETE.SUCCESS'));

                    vm.selectedImageId = undefined;

                    if (vm.params.id) {
                        vm.state.go('images.list');
                    }

                    previousTableState = PaginationService.getTableStateAfterDelete(previousTableState, previousTableState.pagination.take);

                    loadImages();
                } catch (ex) {
                    notification.error(ex.data);
                } finally {
                    stopLoading();
                }
            });
        }
    }

    // function eraseAllFilters() {
    //     loadImages();
    // }

    function startLoading() {
        vm.loading = true;
    }

    function stopLoading() {
        vm.loading = false;
    }

    function dispose() {
        watchers.forEach((x) => x());
    }

    async function print(fileName, extension, code) {
        startLoading();
        const resultat = await ImagesService.print(fileName, extension, code);

        const data = resultat.data;
        const status = resultat.status;
        let headers = resultat.headers;

        headers = headers();

        const contentType = headers['content-type'];

        const linkElement = document.createElement('a');
        try {
            const blob = new Blob([data], { type: contentType + ';charset=UTF-8' });
            const url = window.URL.createObjectURL(blob);
            linkElement.setAttribute('href', url);
            linkElement.setAttribute('download', fileName + '.' + extension);

            const clickEvent = new MouseEvent('click', {
                view: window,
                bubbles: true,
                cancelable: false
            });
            linkElement.dispatchEvent(clickEvent);
        } catch (ex) {
        } finally {
            stopLoading();
        }
    }
}
